import { Logo } from '@insight-health-ai/roseate/components';
import { useTranslation } from 'react-i18next';
const Logout = () => {
  const { t } = useTranslation('auth');
  return (
    <main className="loader-wrapper flex flex-col items-center justify-center w-[100vw] h-[100vh] p-8 text-center">
      <Logo />
      <p className="mt-6 text-base leading-7 text-gray-600">
        {t('logout.description')}
      </p>
    </main>
  );
};

export { Logout };
